import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import { LanguageProvider } from "./lib/i18n/LanguageContext";
import { ThemeProvider } from "./lib/contexts/ThemeContext";
import AnimationWorkflowDemoPage from "./components/pages/AnimationWorkflowDemoPage";
import CotdPage from "./components/pages/CotdPage";
import CotdSessionPage from "./components/pages/CotdSessionPage";
import DemoPage from "./components/pages/DemoPage";
import HomePage from "./components/pages/HomePage";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <div className="min-h-screen bg-white dark:bg-gray-900 text-black dark:text-white flex flex-col">
          <Header />
          <main className="flex-1 flex flex-col">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/cotd" element={<CotdPage />} />
              <Route path="/cotd/session" element={<CotdSessionPage />} />
              <Route path="/demo" element={<DemoPage />} />
              <Route
                path="/demo/animation-workflow"
                element={<AnimationWorkflowDemoPage />}
              />
            </Routes>
          </main>
          </div>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
